<template>

    <v-modal title="Verify Email Address">
        <template #body>
            <v-alert :message="error" />
            <p class="small">Verify your email address to activate your account.<br>An email will be sent to:</p>
            <v-form-group dir="ver">
                <v-input :model="user.email" disabled />
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="verifyEmail">Resend Link</v-button>
        </template>

    </v-modal>

</template>

<script>

import UserApi from '@api/UserApi'

export default {

    props: {
        sender: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    computed: {

        user() {
            return this.$store.getters.user;
        },

    },

    methods: {

        verifyEmail() {
            this.loading = true;
            UserApi.verifyEmail()
                .then((response) => {
                    this.loading = false
                    this.$store.commit('setAlertSuccess', this.$t('message.sent'));
                    this.$store.commit('showModal', false);
                }, (error) => {
                    this.loading = false
                    this.error = error.response.data.message
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
